import { FC, useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { COMMAND_PRIORITY_LOW, PASTE_COMMAND } from 'lexical';
import { INSERT_IMAGE_COMMAND } from './InsertImagePlugin';
import { INSERT_VIDEO_COMMAND } from './InsertVideoPlugin';
import { imageCodeRegex, videoCodeRegex } from '../utils';

export const PasteMediaPlugin: FC = () => {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        return editor.registerCommand<ClipboardEvent>(
            PASTE_COMMAND,
            (event) => {
                const pastedText = event.clipboardData?.getData('Text');
                if (pastedText) {
                    if (imageCodeRegex.test(pastedText)) {
                        editor.dispatchCommand(INSERT_IMAGE_COMMAND, pastedText);
                        return true;
                    }
                    if (videoCodeRegex.test(pastedText)) {
                        editor.dispatchCommand(INSERT_VIDEO_COMMAND, pastedText);
                        return true;
                    }
                }
                return false;
            },
            COMMAND_PRIORITY_LOW,
        )
    }, [editor]); // eslint-disable-line

    return null;
};

export default PasteMediaPlugin;
